import React, { useCallback } from "react";
// import { toJS } from "mobx";
// import { Message } from "~models"
import { Chat } from "~models/chat"
import { useStores } from "~models"
import { globalToast } from "~utils";
import { usePopup } from "~hooks/usePopup";
import useNavigation from "~hooks/useNavigation";
import RedPacketForm from "~pages/app-stack/home-stack/chat-list/red-packet-form";
import TransferForm from "~pages/app-stack/home-stack/chat-list/transfer-form";
import ContactListView from "~pages/app-stack/home-stack/chat-list/components/MemberListView";
import RedPacketPopup from "~pages/app-stack/home-stack/chat-list/red-packet-popup"
import RedPacketDetailPopup from "~pages/app-stack/home-stack/chat-list/red-packet-detail-popup"
import ExclusiveRedPacketDetailPopup from "~pages/app-stack/home-stack/chat-list/exclusive-red-packet-detail-popup"
import TransferReceivePopup from "~pages/app-stack/home-stack/chat-list/transfer-receive-popup"
import TransferDetailPopup from "~pages/app-stack/home-stack/chat-list/transfer-popup"
import UpwardFundsForm from "~pages/app-stack/home-stack/chat-list/upward-funds-form"
import DownwardFundsForm from "~pages/app-stack/home-stack/chat-list/downward-funds-form"
import ContactListViewCard from "~pages/app-stack/home-stack/chat-list/components/ContactListViewCard";
import BlackListViewCard from "~pages/app-stack/home-stack/chat-list/components/BlackListViewCard";
import RedPacketNoticePopup from "~pages/app-stack/home-stack/chat-list/red-packet-notice-popup"
import RedPacketDetailNoticePopup from "~pages/app-stack/home-stack/chat-list/red-packet-detail-notice-popup"
import TransferReceiveNoticePopup from "~pages/app-stack/home-stack/chat-list/transfer-receive-notice-popup"
import TransferDetailNoticePopup from "~pages/app-stack/home-stack/chat-list/transfer-detail-notice-popup"


export const useChatList = (chat?: Chat) => {
    const popup = usePopup();
    const navigation = useNavigation()
    const { apiStore } = useStores()


    const openRedPacketForm = useCallback(async (props: Record<string, any> = {}) => {
        let redPacketPopupPromise: any
        redPacketPopupPromise = popup.open({
            type: "center",
            content: () =>
                React.createElement(RedPacketForm, {
                    ...props,
                    chat: props.chat ?? chat,
                    popupId: redPacketPopupPromise.id,
                }),
        })
        return redPacketPopupPromise.id
    }, [popup, chat])

    const openTransferForm = useCallback(async (props: Record<string, any> = {}) => {
        if (chat?.chatTypeEnum === "GROUP") {
            // 群聊转账先选择联系人
            const p = popup.open({
                type: "center",
                content: React.createElement(ContactListView, {
                    ...props,
                    type: 'transfer',
                    onMemberChange: async (member) => {
                        popup.close(p.id)
                        let transferPopupPromise: any
                        transferPopupPromise = popup.open({
                            type: "bottom",
                            content: () =>
                              React.createElement(TransferForm, {
                                member: member,
                                popupId: transferPopupPromise.id,
                                channelChatInfo: props?.channelChatInfo || {},
                              }),
                        })
                    },
                    onClose: () => {
                        popup.close(p.id)
                    }
                })
            });
            return p.id;
        } else {
            const p = popup.open({
                type: "bottom",
                content: React.createElement(TransferForm, { member: chat?.receiver })
            })
            return p.id;
        }
       
    }, [popup]);

    // 红包
    const openRedPacketPopup = useCallback(async (props) => {
        const p = popup.open({
            type: "center",
            width: 300,
            transparent: true,
            content: React.createElement(RedPacketPopup, {
                ...props,
                onOpen: () => {
                    popup.close(p.id);
                },
                onClose: () => {
                    popup.close(p.id);
                }
            })
        })
        return p.id;
    }, [popup])

    // 红包详情
    const openRedPacketDetailPopup = useCallback(async (props) => {
        const p = popup.open({
            type: "center",
            width: 326,
            transparent: true,
            content: React.createElement(RedPacketDetailPopup, {
                ...props,
                onClose: () => {
                    popup.close(p.id);
                }
            })
        })
        return p.id;
    }, [popup])

     // 专属红包详情
    const openExclusiveRedPacketDetailPopup = useCallback(async (props) => {
        const p = popup.open({
            type: "center",
            width: 300,
            transparent: true,
            content: React.createElement(ExclusiveRedPacketDetailPopup, {
                ...props,
                onClose: () => {
                    popup.close(p.id);
                }
            })
        })
        return p.id;
    }, [popup])

    // 红包详情通知
    const openRedPacketDetailNoticePopup = useCallback(async (props) => {
        const p = popup.open({
            type: "center",
            width: 300,
            transparent: true,
            content: React.createElement(RedPacketDetailNoticePopup, {
                ...props,
                onClose: () => {
                    popup.close(p.id);
                }
            })
        })
        return p.id;
    }, [popup])

    // 红包通知
    const openRedPacketNoticePopup = useCallback(async (props) => {
        const p = popup.open({
            type: "center",
            width: 300,
            transparent: true,
            content: React.createElement(RedPacketNoticePopup, {    
                ...props,
                onOpen: () => {
                    popup.closeAll();
                },
                onClose: () => {
                    popup.close(p.id);
                }
            })
        })
        return p.id;
    }, [popup])

    // 领取转账
    const openTransferPopup = useCallback(async (props) => {
        const p = popup.open({
            type: "center",
            width: 300,
            transparent: true,
            content: React.createElement(TransferReceivePopup, {
                ...props,
                onOpen: () => {
                    popup.close(p.id);
                },
                onClose: () => {
                    popup.close(p.id);
                }
            })
        })
        return p.id;
    }, [popup])

    // 领取转账通知
    const openTransferReceiveNoticePopup = useCallback(async (props) => {
        const p = popup.open({
            type: "center",
            width: 300,
            transparent: true,
            content: React.createElement(TransferReceiveNoticePopup, {
                ...props,
                onOpen: () => {
                    popup.closeAll();
                },
                onClose: () => {
                    popup.close(p.id);
                }
            })
        })
        return p.id;
    }, [popup])

    // 转账详情
    const openTransferDetailPopup = useCallback(async (props) => {
        const p = popup.open({
            type: "center",
            width: 300,
            transparent: true,
            content: React.createElement(TransferDetailPopup, {
                ...props,
                onClose: () => {
                    popup.close(p.id);
                }
            })
        })
        return p.id;
    }, [popup])

    // 转账详情通知
    const openTransferDetailNoticePopup = useCallback(async (props) => {
        const p = popup.open({
            type: "center",
            width: 300,
            transparent: true,
            content: React.createElement(TransferDetailNoticePopup, {
                ...props,
                onClose: () => {
                    popup.close(p.id);
                }
            })
        })
        return p.id;
    }, [popup])

    // 收益统计
    const openRevenueStatistics = useCallback((chat) => {
        navigation.navigate("RevenueStatistics", { chat_id: chat.id, isCurrentUserRole: chat.isCurrentUserRole })
    }, [navigation])

    // 上压资金
    const openUpwardFunds = useCallback(async (props) => {
        let upwardFundsPopup: ReturnType<typeof popup.open> | undefined
        upwardFundsPopup = popup.open({
            type: "center",
            content: () =>
                React.createElement(UpwardFundsForm, {
                    ...props,
                    popupId: upwardFundsPopup!.id,
                }),
        })
        return upwardFundsPopup.id
    }, [popup])

    // 下压资金
    const openDownwardFunds = useCallback(async (props) => {
       const p = popup.open({
            type: "center",
            content: React.createElement(DownwardFundsForm, {
                ...props,
                onConfirm: async (data) => {
                    popup.close(p.id)
                },
                onClose: () => {
                    popup.close(p.id)
                }
            })
        });
       return p.id;
    }, [popup])

    // 跳转个人信息也
    const openPersonalCard = useCallback(async ({ message, chatTypeEnum}) => { 
        try {
            const sender = message.sender
            if (chatTypeEnum === "CHANNEL") return
            if (chatTypeEnum === "PRIVATE") {
                navigation.push("PersonalCard", { userId: sender.id })
                return
            }
            const res = await apiStore.getChannelGroupSettingInfo({ chat_id: message.chat_id, type: 1 })
            if (res?.data?.forbid_add_friend || res?.data?.hide_group_info) {
                return
            }
            navigation.push("PersonalCard", { userId: sender.id })
            return
        } catch (error) {
            globalToast.show(error.message || "操作失败")
        }
    }, [])

    // 分享名片
  const openShareCard  = useCallback(async(
    {
      title = "选择要分享的联系人",
      confirmText = "添加",
      onConfirm,
    }: {
      title?: string,
      confirmText?: string,
      onConfirm?: (contacts: any[]) => void,
    },
  ) => {
    const p = popup.open({
      type: "center",
      content: React.createElement(ContactListViewCard, {
        title,
        confirmText,
        onConfirm: (contacts = []) => {
          onConfirm?.(contacts)
          popup.close(p.id)
        },
        onClose: () => {
          popup.close(p.id)
        }
        })
    })
  }, [popup])
  
  // 屏蔽用户
  const openBlackListView = useCallback(async ({
    title = "选择屏蔽用户",
    confirmText = "屏蔽",
    onConfirm,
  }: {
    title?: string,
    confirmText?: string,
    onConfirm?: (contacts: any[]) => void,
  },) => {
    const p = popup.open({
      type: "center",
      width: "100%",
      content: React.createElement(BlackListViewCard, {
        title,
        confirmText,
        onConfirm: (contacts = []) => {
            onConfirm?.(contacts)
            popup.close(p.id)
          },
          onClose: () => {
            popup.close(p.id)
          }
      }),
      
    })
    return p.id;
  }, [popup])

    return {
        openRedPacketForm,
        openTransferForm,
        openRedPacketPopup,
        openTransferPopup,
        openTransferDetailPopup,
        openRevenueStatistics,
        openUpwardFunds,
        openDownwardFunds,
        openRedPacketDetailPopup,
        openExclusiveRedPacketDetailPopup,
        openPersonalCard,
        openShareCard,
        openRedPacketDetailNoticePopup,
        openRedPacketNoticePopup,
        openTransferReceiveNoticePopup,
        openTransferDetailNoticePopup,
        openBlackListView
    }
};